import { render, staticRenderFns } from "./create.vue?vue&type=template&id=39f8de4a&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"
import style0 from "./create.vue?vue&type=style&index=0&id=39f8de4a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f8de4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39f8de4a')) {
      api.createRecord('39f8de4a', component.options)
    } else {
      api.reload('39f8de4a', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=39f8de4a&scoped=true", function () {
      api.rerender('39f8de4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schedule/create.vue"
export default component.exports